<template>
    <Head title="Terms of Use" />
    <div class="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        <!-- TABLE -->
        <div
            class="bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-gray-200 mb-8 max-w-[60rem] mx-auto py-10 px-5"
        >
            <div
                class="mx-auto max-w-[50rem] prose-sm prose prose-slate prose-a:font-semibold prose-a:text-orange-400 hover:prose-a:text-orange-700"
            >
                <section class="mb-12 text-center">
                    <h1
                        class="text-2xl md:text-3xl text-gray-800 font-bold mb-2"
                    >
                        My10x: Terms of Use
                    </h1>
                    <p>
                        <strong>Effective Date:</strong>
                        <br />
                        October 1, 2022&nbsp;
                    </p>
                </section>

                <section class="mb-8">
                    <ol>
                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Applicability and Scope
                            </strong>

                            <p>
                                These Terms of Use are the only terms that
                                govern the use of our website and provision of
                                services between you and Aethereal ("
                                <strong>Company</strong>
                                ," "
                                <strong>we</strong>
                                ," or "
                                <strong>us</strong>
                                ").&nbsp;
                            </p>
                            <p>
                                The following terms, along with any documents,
                                policies, or agreements expressly incorporated
                                into these terms, constitute the "
                                <strong>Terms</strong>
                                " that will govern the provision of services and
                                use of www.10xtravel.com and www.MileValue.com,
                                including, any content, functionality, and
                                services offered on or through www.10xtravel.com
                                and www.MileValue.com or any subdomain of such
                                websites (together the "
                                <strong>Website</strong>
                                "). These Terms supersede all prior or
                                contemporaneous understandings, agreements,
                                negotiations, representations and warranties,
                                and communications, whether written or oral. If
                                we provide an order confirmation or separate
                                scope of work, those documents will govern over
                                any conflicting provisions with these
                                Terms.&nbsp; These Terms apply to you whether
                                you are a guest or a registered user.
                            </p>
                            <p>
                                All determinations of eligibility are based on
                                our own estimates based on the data provided.
                                Our determinations of eligibility are not
                                endorsed by any bank. The accuracy of
                                eligibility is not guaranteed.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Acceptance of Terms
                            </strong>

                            <p>
                                Please read these Terms of Use carefully before
                                you start to use the Website. By checking the
                                box indicating "
                                <strong>Accept</strong>
                                ," you accept and agree to be bound and abide by
                                these Terms and our Privacy Policy, incorporated
                                herein by reference. If you do not want to agree
                                to these Terms or the Privacy Policy, you must
                                not access or use the Website or our
                                services.&nbsp;
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Changes to These Terms
                            </strong>

                            <p>
                                We may revise and update these Terms from time
                                to time at our sole discretion. All changes are
                                effective as of the Effective Date above and
                                will apply to all access to and use of the
                                Website thereafter.
                            </p>
                            <p>
                                By checking the box indicating an agreement to
                                our Terms following the posting of revised Terms
                                means that you accept and agree to the changes.
                                You are expected to check this page from time to
                                time, so you may be aware of any changes, as
                                they are binding upon you.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Age Restriction
                            </strong>

                            <p>
                                This Website is offered and available to users
                                who are at least 16 years of age or older. By
                                using this Website, you represent that you meet
                                all of the foregoing eligibility requirements.
                                If you do not meet all of these requirements,
                                you must not access or use the Website.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Services
                            </strong>

                            <p>
                                We are proud to offer our Award Booking Service
                                (the &ldquo;
                                <strong>Service</strong>
                                &rdquo;). We will provide the Service to you as
                                described in the Order Confirmation or Statement
                                of Work. Before we begin to provide our
                                Services, you are required to submit a deposit
                                in the amount indicated in the Order
                                Confirmation or Statement of Work. The deposit
                                amount will be credited to the purchase price if
                                we are able to successfully provide a
                                deliverable to you. In the event that we are not
                                able to provide a deliverable after diligent and
                                good-faith efforts, we will keep the deposit
                                amount, but you will not be charged the
                                remaining purchase price for the Service.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Relationship of Parties and 3rd Parties
                            </strong>

                            <p>
                                Your use and registration with our Website does
                                not create an agency relationship, partnership,
                                joint venture, employment, or fiduciary
                                relationship. Neither party has the authority to
                                bind the other in any manner for any reason
                                whatsoever.
                            </p>
                            <p>
                                These Terms are for the sole benefit of you and
                                the Company, and our respective successors and
                                assigns. Nothing herein is intended to or shall
                                confer upon any other party any legal or
                                equitable right, benefit, or remedy of any
                                nature.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Performance
                            </strong>

                            <p>
                                We will use commercially reasonable efforts to
                                meet any performance, completion, or delivery
                                dates indicated in the Order Confirmation or
                                Statement of Work.&nbsp;
                            </p>
                            <p>
                                However, any such date is only an estimate. We
                                do not warrant against the date of completion.
                                We are not responsible for any expenses incurred
                                as a result of any delay in performance or
                                delivery.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Accessing the Website and Our Security
                            </strong>
                            <p>
                                We reserve the right to withdraw or amend this
                                Website, and any Service, material, or content
                                we provide on the Website, in our sole
                                discretion, without notice. We will not be
                                liable if, for any reason, all or any part of
                                the Website is unavailable at any time or for
                                any period. From time to time, we may restrict
                                access to some parts of the Website, or the
                                entire Website, to users, including registered
                                users and guests.
                            </p>
                            <p>You are responsible for both:&nbsp;</p>
                            <ul>
                                <li>
                                    Making all arrangements necessary for you to
                                    have access to the Website.
                                </li>
                                <li>
                                    Ensuring that all persons who access the
                                    Website through your internet connection are
                                    aware of these Terms and comply with them.
                                </li>
                            </ul>
                            <p>
                                To access the Website or some of the resources
                                it offers, you may be asked to provide certain
                                registration details or other information. It is
                                a condition of your use of the Website that all
                                the information you provide on the Website is
                                correct, current, and complete. You agree that
                                all information you provide to register with
                                this Website or otherwise, including, but not
                                limited to, through the use of any interactive
                                features on the Website, is governed by our
                                Privacy Policy, and you consent to all actions
                                we take with respect to your information
                                consistent with our Privacy Policy.
                            </p>
                            <p>
                                If you choose or are provided with a username,
                                password, or any other piece of information as
                                part of our security procedures, you must treat
                                such information as confidential, and you must
                                not disclose it to any other person or
                                entity.&nbsp;
                            </p>
                            <p>
                                You also acknowledge that your account is
                                personal to you and agree not to provide any
                                other person with access to this Website or
                                portions of it using your username, password, or
                                other security information. You agree to notify
                                us immediately of any unauthorized access to or
                                use of your username or password or any other
                                breach of security. You also agree to ensure
                                that you exit from your account at the end of
                                each session. You should use particular caution
                                when accessing your account from a public or
                                shared computer so that others are not able to
                                view or record your password or other personal
                                information.
                            </p>
                            <p>
                                We have the right to disable any username,
                                password, or other identifiers, whether chosen
                                by you or provided by us, at any time in our
                                sole discretion for any or no reason, including
                                if, in our opinion, you have violated any
                                provision of these Terms.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Your Obligations
                            </strong>

                            <p>You, at all times, agree to:</p>
                            <ol>
                                <li>
                                    Comply with our policies and guidelines.
                                </li>
                                <li>
                                    Respond promptly to any of our requests for
                                    you to provide instruction, information,
                                    approvals, authorizations, or decisions that
                                    are necessary for us to perform the Services
                                    in accordance with these Terms.
                                </li>
                                <li>
                                    Provide such materials or information that
                                    we may request to carry out the Services in
                                    a timely manner and ensure that such
                                    materials or information are complete and
                                    accurate in all material respects.
                                </li>
                                <li>
                                    Obtain and maintain all necessary licenses
                                    and consents and comply with all applicable
                                    laws in relation to the Services before the
                                    date on which the Services are set to begin.
                                </li>
                                <li>
                                    If our performance is prevented or delayed
                                    because of an act or omission of your doing,
                                    or if your failure to comply with these
                                    Terms causes a delay in performance, we will
                                    not be deemed to be in breach of our
                                    obligations under the agreement. We will not
                                    be liable for any costs, charges, expenses,
                                    or losses sustained or incurred by you, in
                                    each case, to the extent arising directly or
                                    indirectly from such prevention or delay.
                                </li>
                            </ol>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Prohibited Uses
                            </strong>

                            <p>
                                You agree that you will only use the Website for
                                lawful purposes, in accordance with all
                                applicable laws, rules, regulations, and these
                                Terms. The following is a non-exhaustive list of
                                prohibited activities that you agree to not to
                                engage in:
                            </p>
                            <ol>
                                <li>
                                    Violating any applicable federal, state,
                                    local, or international law or regulation
                                    (including, without limitation, any laws
                                    regarding the export of data or software to
                                    and from the US or other countries).
                                </li>
                                <li>
                                    Exploiting, harming, or attempting to
                                    exploit or harm minors in any way by
                                    exposing them to inappropriate content,
                                    asking for personally identifiable
                                    information, or otherwise.
                                </li>
                                <li>
                                    Sending, knowingly receiving, uploading,
                                    downloading, using, or re-using any material
                                    which does not comply with the Content
                                    Standards set out in these Terms.
                                </li>
                                <li>
                                    Transmitting any advertising or promotional
                                    material, including any &ldquo;junk
                                    mail,&rdquo; &ldquo;chain letter,&rdquo;
                                    &ldquo;spam,&rdquo; or any other similar
                                    solicitation.
                                </li>
                                <li>
                                    Impersonating or attempting to impersonate
                                    the Company or its subsidiary or division, a
                                    Company employee or representative, another
                                    user, or any other person or entity
                                    (including, without limitation, by using
                                    e-mail addresses or screen names associated
                                    with any of the foregoing).
                                </li>
                                <li>
                                    Misrepresenting your identity or affiliation
                                    with any person or entity.
                                </li>
                                <li>
                                    Engaging in any other conduct that restricts
                                    or inhibits anyone's use or enjoyment of the
                                    Website, or which, as determined by us, may
                                    harm the Company or users of the Website, or
                                    expose them to liability.
                                </li>
                                <li>
                                    Using the Website in any manner that could
                                    disable, overburden, damage, or impair the
                                    site or interfere with any other party's use
                                    of the Website.
                                </li>
                                <li>
                                    Using any automatic device, process, or
                                    means to access the Website for any purpose,
                                    including monitoring or copying any of the
                                    material on the Website.
                                </li>
                                <li>
                                    Using any manual process to monitor or copy
                                    any of the material on the Website, or for
                                    any other purpose not expressly authorized
                                    in these Terms of Use, without our prior
                                    written consent.
                                </li>
                                <li>
                                    Using any device, software, or routine that
                                    interferes with the proper working of the
                                    Website.
                                </li>
                                <li>
                                    Introducing any viruses, trojan horses,
                                    worms, logic bombs, or other material which
                                    is malicious or technologically harmful.
                                </li>
                                <li>
                                    Attempting to gain unauthorized access to,
                                    interfere with, damage, or disrupt any parts
                                    of the Website, the server on which the
                                    Website is stored, or any server, computer,
                                    or database connected to the Website.&nbsp;
                                </li>
                                <li>
                                    Attacking the Website via a
                                    denial-of-service attack or a distributed
                                    denial-of-service attack.
                                </li>
                                <li>
                                    Otherwise, attempting to interfere with the
                                    proper working of the Website.
                                </li>
                            </ol>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                User Contributions
                            </strong>
                            <p>
                                The Website allows members to place information
                                or unique content on certain pages of the
                                Website.
                            </p>
                            <p>
                                All User Contributions must comply with the
                                Content Standards set out in these Terms.Any
                                User Contribution you post to the site will be
                                considered non-confidential and non-proprietary.
                                By providing any User Contribution on the
                                Website, you grant us and our affiliates and
                                service providers, and each of their and our
                                respective licensees, successors, and assigns
                                the right to use, reproduce, modify, perform,
                                display, distribute, and otherwise disclose to
                                third parties any such material for any
                                purpose.&nbsp;
                            </p>
                            <p>You state that:&nbsp;</p>
                            <ol>
                                <li>
                                    You own or control all rights in and to the
                                    User Contributions and have the right to
                                    grant the license granted above to us and
                                    our affiliates and service providers, and
                                    each of their and our respective licensees,
                                    successors, and assigns.
                                </li>
                                <li>
                                    All of your User Contributions do and will
                                    comply with these Terms.
                                </li>
                            </ol>

                            <p>
                                You understand and acknowledge that you are
                                responsible for any User Contributions you
                                submit or contribute, and you, not the Company,
                                have full responsibility for such content,
                                including its legality, reliability, accuracy,
                                and appropriateness.
                            </p>
                            <p>
                                We are not responsible, or liable to any third
                                party, for the content or accuracy of any User
                                Contributions posted by you or any other user of
                                the Website.
                            </p>
                            <p>
                                When you make a comment or upload any content
                                onto the Application, you agree that such
                                comment or content may be viewed by other
                                parties and it is your responsibility to ensure
                                that the comment or content does not contain any
                                confidential or proprietary information. You are
                                also responsible for ensuring that your content
                                or comment complies with the Content Standards.
                                We reserve the right to remove any content or
                                comment at any time at our sole discretion.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Content Standards
                            </strong>

                            <p>
                                These content standards apply to any and all
                                User Contributions. User Contributions must in
                                their entirety comply with all applicable
                                federal, state, local and international laws and
                                regulations. Without limiting the foregoing,
                                User Contributions must not:
                            </p>
                            <ol>
                                <li>
                                    Contain any material which is defamatory,
                                    obscene, indecent, abusive, offensive,
                                    harassing, violent, hateful, inflammatory,
                                    or otherwise objectionable.
                                </li>
                                <li>
                                    Promote sexually explicit or pornographic
                                    material, violence, or discrimination based
                                    on race, sex, religion, nationality,
                                    disability, sexual orientation, or age.
                                </li>
                                <li>
                                    Infringe any patent, trademark, trade
                                    secret, copyright, or other intellectual
                                    property or other rights of any other person
                                    or legal entity.
                                </li>
                                <li>
                                    Violate the legal rights (including the
                                    rights of publicity and privacy) of others
                                    or contain any material that could give rise
                                    to any civil or criminal liability under
                                    applicable laws or regulations or that
                                    otherwise may be in conflict with these
                                    Terms of Use and our Privacy Policy.
                                </li>
                                <li>Be likely to deceive any person.</li>
                                <li>
                                    Promote any illegal activity, or advocate,
                                    promote or assist any unlawful act.
                                </li>
                                <li>
                                    Cause annoyance, inconvenience, or needless
                                    anxiety or be likely to upset, embarrass,
                                    alarm, or annoy any other person.
                                </li>
                                <li>
                                    Impersonate any person or misrepresent your
                                    identity or affiliation with any person or
                                    organization.
                                </li>
                                <li>
                                    Involve activities constituting a contest,
                                    sweepstakes, or lottery.
                                </li>
                                <li>
                                    Give the impression that they emanate from
                                    or are endorsed by us or any other person or
                                    entity if this is not the case.
                                </li>
                            </ol>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Reliance on Information Posted
                            </strong>

                            <p>
                                The information presented on or through the
                                Website is made available solely for general
                                information purposes. We do not warrant the
                                accuracy, completeness, or usefulness of this
                                information. Any reliance you place on such
                                information is strictly at your own risk. We
                                disclaim all liability and responsibility
                                arising from any reliance placed on such
                                materials by you or any other visitor to the
                                Website, or by anyone who may be informed of any
                                of its contents.
                            </p>
                            <p>
                                This Website includes content provided by third
                                parties. All statements, quotes, and/or opinions
                                expressed in these materials, and all articles
                                and responses to questions and other content,
                                other than the content provided by the Company,
                                are solely the opinions and the responsibility
                                of the person or entity providing those
                                materials. These materials do not necessarily
                                reflect the opinion of the Company. We are not
                                responsible, or liable to you or any third
                                party, for the content or accuracy of any
                                materials provided by any third parties.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Monitoring and Enforcement
                            </strong>

                            <p>We have the right to:</p>
                            <ol>
                                <li>
                                    Take any action with respect to any User
                                    Contribution that we deem necessary or
                                    appropriate in our sole discretion,
                                    including if we believe that such User
                                    Contribution violates these Terms, including
                                    the Content Standards, infringes any
                                    intellectual property right or other rights
                                    of any person or entity, threatens the
                                    personal safety of users of the Website or
                                    the public or could create liability for the
                                    Company.
                                </li>
                                <li>
                                    Disclose your identity or other information
                                    about you to any third party who claims that
                                    material posted by you violates their
                                    rights, including their intellectual
                                    property rights or their right to privacy.
                                </li>
                                <li>
                                    Take appropriate legal action, including,
                                    without limitation, referral to law
                                    enforcement for any illegal or unauthorized
                                    use of the Website or Service.&nbsp;
                                </li>
                                <li>
                                    Terminate or suspend your access to all or
                                    part of the Website for any or no reason,
                                    including without limitation, any violation
                                    of these Terms.
                                </li>

                                <p>
                                    Without limiting the foregoing, we have the
                                    right to fully cooperate with any law
                                    enforcement authorities or court order
                                    requesting or directing us to disclose the
                                    identity or other information of anyone
                                    posting any materials on or through the
                                    Website. YOU WAIVE AND HOLD HARMLESS THE
                                    COMPANY AND ITS AFFILIATES, LICENSEES, AND
                                    SERVICE PROVIDERS FROM ANY CLAIMS RESULTING
                                    FROM ANY ACTION TAKEN BY ANY OF THE
                                    FOREGOING PARTIES DURING OR AS A RESULT OF
                                    ITS INVESTIGATIONS AND FROM ANY ACTIONS
                                    TAKEN AS A CONSEQUENCE OF INVESTIGATIONS BY
                                    EITHER SUCH PARTIES OR LAW ENFORCEMENT
                                    AUTHORITIES.
                                </p>
                                <p>
                                    While we do review content after it is
                                    posted to the Website, we cannot ensure
                                    prompt removal of objectionable material
                                    after it has been posted. Accordingly, we
                                    assume no liability for any action or
                                    inaction regarding transmissions,
                                    communications, or content provided by any
                                    Website user. We have no liability or
                                    responsibility to anyone for the performance
                                    or nonperformance of the activities
                                    described in this section.
                                </p>
                            </ol>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Our Intellectual Property
                            </strong>

                            <p>
                                We own the following trademarks registered with
                                the U.S. Patent and Trademark Office: "10X
                                TRAVEL", Registration No. 6041376, first use in
                                commerce April 30, 2016.
                            </p>
                            <p>
                                The name Aethereal, the domain names
                                10xTravel.com and MileValue.com, the Website and
                                its entire contents, features, and
                                functionality, including but not limited to all
                                logos, graphics, data, information, software,
                                text, displays, images, video and audio, and the
                                design, selection, and arrangement or
                                derivations thereof, as well as any documents or
                                work product and other material delivered to you
                                by us in the course of performance (the "
                                <strong>Deliverables</strong>
                                "), except for your confidential information,
                                are owned by the Company, its licensors or other
                                providers of such material and are protected by
                                United States and international copyright,
                                trademark, trade secret, and other intellectual
                                property or proprietary rights laws. We hereby
                                grant you a license to use all Intellectual
                                Property Rights in the Deliverables free of
                                additional charge and on a non-exclusive,
                                worldwide, non-transferable, non-sublicensable,
                                fully paid-up, royalty-free and perpetual basis,
                                solely to the extent necessary to enable your to
                                make reasonable use of the Deliverables and the
                                Services.&nbsp;
                            </p>
                            <p>
                                You must not reproduce, distribute, modify,
                                create derivative works of, publicly display,
                                publicly perform, republish, download, store or
                                transmit any of the material on our Website or
                                our Deliverables, except as follows:
                            </p>

                            <ol>
                                <li>
                                    Your computer may temporarily store copies
                                    of such materials in RAM incidental to your
                                    accessing and viewing of those materials.
                                </li>
                                <li>
                                    You may store files that are automatically
                                    cached by your Web browser for display
                                    enhancement purposes.
                                </li>
                                <li>
                                    If we provide desktop, mobile or other
                                    applications for download, you may download
                                    a single copy to your computer or mobile
                                    device solely for your own personal use,
                                    provided you agree to be bound by our end
                                    user license agreement for such
                                    applications.
                                </li>
                                <li>
                                    If we provide social media features with
                                    certain content, you may take such actions
                                    as are enabled by such features.
                                </li>
                            </ol>
                            <p>You must not:</p>
                            <ol>
                                <li>
                                    Modify copies of any materials from this
                                    Website or the Deliverables.
                                </li>
                                <li>
                                    Delete or alter any copyright, trademark, or
                                    other proprietary rights notices from copies
                                    of materials from this Website or the
                                    Deliverables.&nbsp;
                                </li>
                            </ol>
                            <p>
                                If you wish to make any use of material on the
                                Website or in the Deliverables other than that
                                set out in this section, please address your
                                request to: contact@10xtravel.com.
                            </p>
                            <p>
                                If you print, copy, modify, download, or
                                otherwise use or provide any other person with
                                access to any part of the Website in breach of
                                these Terms, your right to use the Website and
                                Service will cease immediately, and you must, at
                                our option, return or destroy any copies of the
                                materials you have made. No right, title, or
                                interest in or to the Website or Service or any
                                content on the Website or Service is transferred
                                to you, and all rights not expressly granted are
                                reserved by the Company. Any use of the Website
                                or Service not expressly permitted by these
                                Terms is a breach of these Terms and may violate
                                copyright, trademark, and other laws.
                            </p>
                            <p>
                                If you are aware of a potential infringement of
                                our intellectual property, please contact us at
                                contact@10xtravel.com.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Intellectual Property of Others
                            </strong>

                            <p>
                                We respect the intellectual property rights of
                                others. It is our policy to respond to any
                                claims of infringement of the copyright,
                                trademark, or other intellectual property rights
                                of any person or entity and cease such
                                infringing use and terminate the user accounts
                                of repeat infringers.
                            </p>
                            <p>
                                If you believe in good faith that your
                                intellectual property rights have been infringed
                                upon, you or your agent may send us written
                                notice of such infringement. Your notice to us
                                must include the following information:
                            </p>

                            <ol>
                                <li>
                                    An electronic or physical signature of the
                                    person authorized to act on behalf of the
                                    owner of the intellectual property
                                    right&rsquo;s interest;
                                </li>
                                <li>
                                    A description of the work that you claim has
                                    been infringed, including the URL (i.e., web
                                    page address) of the location where the work
                                    exists or a copy of the work;
                                </li>
                                <li>
                                    Your name, email, address, and telephone
                                    number; and
                                </li>
                                <li>
                                    A statement by you that you have a good
                                    faith belief that the disputed use is not
                                    authorized by the owner of the work, its
                                    agent, or the law.
                                </li>
                            </ol>
                            <p>
                                Please note that we may not process your
                                complaint if it is not properly filled out or is
                                incomplete. You may be held accountable for
                                damages, including but not limited to costs and
                                attorneys&rsquo; fees for any misrepresentation
                                or bad-faith claims regarding the infringement
                                of your intellectual property rights.
                            </p>
                            <p>
                                You may submit your claim to us by contacting us
                                at: contact@10xtravel.com.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Linking to the Website and Social Media
                            </strong>

                            <p>
                                You may not link to our Website in any way that
                                would establish or suggest any form of
                                association, approval, or endorsement on our
                                part.
                            </p>
                            <p>
                                However, this Website may provide certain social
                                media features that enable you to link from the
                                social media website to certain content on this
                                Website.
                            </p>
                            <p>
                                You may use these features solely as they are
                                provided by us and solely with respect to the
                                content they are displayed with. Subject to the
                                foregoing, you must not:
                            </p>
                            <ol>
                                <li>
                                    Establish a link from any website, whether
                                    owned by you or not.
                                </li>
                                <li>
                                    Cause the Website or portions of it to be
                                    displayed, or appear to be displayed by, for
                                    example, framing, deep linking or in-line
                                    linking, on any other site.
                                </li>
                                <li>
                                    Link to any part of the Website other than
                                    the homepage, your Member page, or a page
                                    containing only your User Contributions.
                                </li>
                                <li>
                                    Take any action with respect to the
                                    materials on this Website that is
                                    inconsistent with any other provision of
                                    these Terms.
                                </li>
                            </ol>
                            <p>
                                You agree to cooperate with us in causing any
                                unauthorized framing or linking immediately to
                                cease.&nbsp;
                            </p>
                            <p>
                                We may disable all or any social media features
                                and any links at any time without notice at our
                                discretion.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Links From the Website
                            </strong>

                            <p>
                                The Website contains links to other sites and
                                resources provided by third parties. These links
                                are provided for your convenience only. We have
                                no control over the contents of those sites or
                                resources and accept no responsibility for them
                                or for any loss or damage that may arise from
                                your use of them. If you decide to access any of
                                the third-party websites linked to this Website,
                                you do so entirely at your own risk and subject
                                to the terms and conditions of use for such
                                websites. We suggest that you review the third
                                party website's privacy policy and terms of use
                                before engaging with it.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Purchases
                            </strong>

                            <p>
                                You may submit orders to us on our
                                Website.&nbsp;
                            </p>
                            <p>
                                Only prices quoted by us will constitute a valid
                                offer of sale and/or delivery. Quoted prices are
                                subject to change without notice. Unless agreed
                                to otherwise, a price change will only affect
                                contracts entered into after the price change.
                                We may accept or reject any order at our sole
                                discretion. A binding agreement will arise only
                                after we affirmatively confirm your order. We
                                reserve the right to discontinue the offering of
                                any service at any time.
                            </p>
                            <p>
                                In consideration of the provision of the
                                Services and the rights granted to you under
                                this agreement, you shall pay the fees,
                                expenses, and taxes set forth in the invoice.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Memberships
                            </strong>

                            <p>
                                When you register on our Service, you become a
                                Member. We offer various degrees of our
                                membership, which will give you access to
                                different features of our Website or Service.
                            </p>
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <strong>Membership Tier</strong>
                                            </td>
                                            <td><strong>Term</strong></td>
                                            <td><strong>Price</strong></td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style="color: #2b3542">
                                                    Basic
                                                </span>
                                            </td>
                                            <td>
                                                <span style="color: #2b3542">
                                                    Perpetual
                                                </span>
                                            </td>
                                            <td>
                                                <span style="color: #2b3542">
                                                    Free
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style="color: #2b3542">
                                                    Premium
                                                </span>
                                            </td>
                                            <td>
                                                <span style="color: #2b3542">
                                                    Annual
                                                </span>
                                            </td>
                                            <td>
                                                <span style="color: #2b3542">
                                                    $199
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p>
                                If you have chosen not to register for our
                                Membership, you may still access certain
                                features as a Guest.
                            </p>
                            <p>
                                You agree to pay the necessary fees for your
                                membership, which are subject to change at our
                                sole discretion. Dues will be billed pursuant to
                                the Term indicated in the Membership plan you
                                have chosen, which payment is required pursuant
                                to the payment terms in the Payments, Fees,
                                Taxes, and Expenses section.&nbsp;
                            </p>
                            <p>
                                We also have the right to suspend or terminate
                                your membership for any reason, including (i) if
                                you fail to pay your fees on time and (ii) if
                                you violate our Terms.
                            </p>
                            <p>
                                If you cancel within 14 days of joining, we
                                guarantee a refund of 100% of the fees that were
                                paid by you.&nbsp;
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Payments, Fees, Taxes, and Expenses
                            </strong>

                            <p>
                                You must pay all invoiced amounts due to us
                                within 30 days from the date of our invoice.
                            </p>
                            <p>
                                You must make all payments to us in the currency
                                designated on the invoice.&nbsp;
                            </p>
                            <p>
                                You may only pay through our third party payment
                                processor.
                            </p>
                            <p>
                                You are responsible for paying all sales, use,
                                and excise taxes, and any other similar taxes,
                                duties, and charges of any kind imposed by any
                                federal, state, or local governmental entity on
                                any amounts payable by you hereunder.&nbsp;
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Renewal
                            </strong>

                            <p>
                                The membership will automatically renew upon
                                each anniversary date of the applicable term, at
                                the then applicable fee for your renewal
                                published here, unless earlier terminated in
                                accordance with the Term and Termination section
                                below.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Late Payments
                            </strong>

                            <p>
                                In the event that payments are not received
                                within the timeframe designated in the Payments,
                                Fees, Taxes, and Expenses section above, we may
                                suspend your access to the paid portions of the
                                Website and our performance until payment has
                                been received.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Changes in Performance
                            </strong>

                            <p>
                                If either party wishes to change the scope of
                                performance, it must submit details of the
                                requested change to the other party in writing.
                                Neither of us will be bound by any change unless
                                agreed upon in writing.
                            </p>
                            <p>
                                Notwithstanding the preceding paragraph of this
                                section, we may, from time to time, change the
                                performance without your consent if such changes
                                do not materially affect the nature or scope of
                                performance, deliverables, fees, or any
                                performance dates set forth in the agreement
                                that these terms apply.
                            </p>
                            <p>
                                We may charge for the time it spends assessing
                                and documenting a change request from you on a
                                time and materials basis following any change in
                                performance.&nbsp;
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Cancellation
                            </strong>

                            <p>
                                You may cancel your membership at any time by
                                emailing us at contact@10xtravel.com.
                            </p>
                            <p>
                                If you cancel your membership, it will not
                                automatically renew, and you will not be charged
                                for the renewals. Please note that you will
                                cease to receive access to the membership
                                benefits on or after the end of the current
                                billing cycle.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Refunds
                            </strong>

                            <p>
                                Notwithstanding the refunds offered for
                                memberships under Section 21 hereof, we do not
                                guarantee a refund on purchases made on our
                                Website or Service. The determination of whether
                                a refund will be given and the amount of the
                                refund is at our sole discretion, and we are
                                under no obligation to issue a refund of any
                                fees.&nbsp;
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Representations and Warranties
                            </strong>

                            <p>
                                We promise to you that we shall perform the
                                Services using personnel of required skill,
                                experience, and qualifications and in a
                                professional and workmanlike manner following
                                generally recognized industry standards for
                                similar services and shall devote adequate
                                resources to meet its obligations under these
                                Terms.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Disclaimer of Warranties
                            </strong>

                            <p>
                                You understand that we cannot and do not
                                guarantee or warrant that files available for
                                downloading from the internet or the Website
                                will be free of viruses or other destructive
                                code. You are responsible for implementing
                                sufficient procedures and checkpoints to satisfy
                                your particular requirements for anti-virus
                                protection and accuracy of data input and output
                                and for maintaining a means external to our site
                                for any reconstruction of any lost data.&nbsp;
                            </p>
                            <p>
                                WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE
                                CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE
                                ATTACK, VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL
                                MATERIAL THAT MAY INFECT YOUR COMPUTER
                                EQUIPMENT, COMPUTER PROGRAMS, DATA OR OTHER
                                PROPRIETARY MATERIAL DUE TO YOUR USE OF THE
                                WEBSITE OR ANY SERVICES OR ITEMS OBTAINED
                                THROUGH THE WEBSITE OR TO YOUR DOWNLOADING OF
                                ANY MATERIAL POSTED ON IT, OR ON ANY WEBSITE
                                LINKED TO IT.
                            </p>
                            <p>
                                YOUR USE OF THE WEBSITE, ITS CONTENT AND ANY
                                SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE
                                IS AT YOUR OWN RISK. THE WEBSITE, ITS CONTENT
                                AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE
                                WEBSITE ARE PROVIDED ON AN &ldquo;AS IS&rdquo;
                                AND &ldquo;AS AVAILABLE&rdquo; BASIS, WITHOUT
                                ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR
                                IMPLIED. NEITHER THE COMPANY NOR ANY PERSON
                                ASSOCIATED WITH THE COMPANY MAKES ANY WARRANTY
                                OR REPRESENTATION WITH RESPECT TO THE
                                COMPLETENESS, SECURITY, RELIABILITY, QUALITY,
                                ACCURACY OR AVAILABILITY OF THE WEBSITE OR ITS
                                CONTENT. WITHOUT LIMITING THE FOREGOING, NEITHER
                                THE COMPANY NOR ANYONE ASSOCIATED WITH THE
                                COMPANY REPRESENTS OR WARRANTS THAT THE WEBSITE,
                                ITS CONTENT OR ANY SERVICES OR ITEMS OBTAINED
                                THROUGH THE WEBSITE WILL BE ACCURATE, RELIABLE,
                                ERROR-FREE OR UNINTERRUPTED, THAT DEFECTS WILL
                                BE CORRECTED, THAT OUR SITE OR THE SERVER THAT
                                MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER
                                HARMFUL COMPONENTS OR THAT THE WEBSITE OR ANY
                                SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE
                                WILL OTHERWISE MEET YOUR NEEDS OR
                                EXPECTATIONS.&nbsp;
                            </p>
                            <p>
                                WE MAKE NO WARRANTY WHATSOEVER WITH RESPECT TO
                                THE YOUR USE OF OUR WEBSITE OR OUR PROVISION OF
                                SERVICES, INCLUDING ANY (A) WARRANTY OF
                                MERCHANTABILITY; OR (B) WARRANTY OF FITNESS FOR
                                A PARTICULAR PURPOSE; OR (C) WARRANTY OF TITLE;
                                OR (D) WARRANTY AGAINST INFRINGEMENT OF
                                INTELLECTUAL PROPERTY RIGHTS OF A THIRD PARTY;
                                WHETHER EXPRESSED OR IMPLIED BY LAW, STATUTORY,
                                COURSE OF DEALING, COURSE OF PERFORMANCE, USAGE
                                OF TRADE, OR OTHERWISE.&nbsp;
                            </p>
                            <p>
                                THE FOREGOING DOES NOT AFFECT ANY WARRANTIES
                                WHICH CANNOT BE EXCLUDED OR LIMITED UNDER
                                APPLICABLE LAW.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Limitation of Liability
                            </strong>

                            <p>
                                TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO
                                EVENT WILL WE, OUR AFFILIATES OR LICENSORS,
                                SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS
                                OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND,
                                UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN
                                CONNECTION WITH YOUR OR ANY THIRD PARTY'S USE,
                                OR INABILITY TO USE, THE WEBSITE, ANY WEBSITES
                                LINKED TO IT, ANY CONTENT ON THE WEBSITE OR SUCH
                                OTHER WEBSITES OR ANY SERVICES OR ITEMS OBTAINED
                                THROUGH THE WEBSITE OR SUCH OTHER WEBSITES,
                                INCLUDING ANY DIRECT, INDIRECT, SPECIAL,
                                INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES,
                                INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY,
                                PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF
                                REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR
                                ANTICIPATED SAVINGS, DIMINUTION IN VALUE, LOSS
                                OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND
                                WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE),
                                BREACH OF CONTRACT OR OTHERWISE, EVEN IF THE
                                DAMAGES WERE FORESEEABLE.
                            </p>
                            <p>
                                IN NO EVENT WILL OUR AGGREGATE LIABILITY ARISING
                                OUT OF OR RELATED TO YOUR USE OF OUR WEBSITE OR
                                SERVICE OR ITEMS OBTAINED THROUGH THE WEBSITE OR
                                SERVICE EXCEED THE AMOUNTS PAID OR PAYABLE TO US
                                PURSUANT TO THESE TERMS WITHIN THE 12-MONTH
                                PERIOD PRECEDING THE EVENT GIVING RISE TO THE
                                CLAIM.
                            </p>
                            <p>
                                THE FOREGOING DOES NOT AFFECT ANY LIABILITY
                                WHICH CAN NOT BE EXCLUDED OR LIMITED UNDER
                                APPLICABLE LAW SUCH AS LIABILITY ARISING OUT OF
                                GROSS NEGLIGENCE OR WILLFUL MISCONDUCT.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Confidential Information
                            </strong>

                            <p>
                                All of our non-public, confidential or
                                proprietary information that is considered by a
                                reasonable person to be confidential
                                (collectively, "
                                <strong>Confidential Information</strong>
                                "), disclosed by us to you, whether or not
                                marked, designated or otherwise identified as
                                "confidential" in connection with the provision
                                of the Services and this Website is
                                confidential, and shall not be disclosed or
                                copied by you without our prior written consent.
                                Confidential Information does not include
                                information that is:a.in the public
                                domain;b.known by you at the time of disclosure;
                                orc.rightfully obtained by you on a
                                non-confidential basis from a third party.You
                                agree to use the Confidential Information only
                                to make use of the Services and Website. We are
                                entitled to injunctive relief for any violation
                                of this section.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Indemnification
                            </strong>

                            <p>
                                You agree to defend, indemnify and hold us
                                harmless, our affiliates, licensors and service
                                providers, and our and their respective
                                officers, directors, employees, contractors,
                                agents, licensors, suppliers, successors and
                                assigns from and against any claims,
                                liabilities, damages, judgments, awards, losses,
                                costs, expenses or fees (including reasonable
                                attorneys' fees) arising out of or relating to
                                your violation of these Terms or your use of the
                                Website, including, but not limited to, your
                                User Contributions, any use of the Website's
                                content, services and products other than as
                                expressly authorized in these Terms, or your use
                                of any information obtained from the Website.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Assignment
                            </strong>

                            <p>
                                You may not assign any of your rights or
                                delegate any of your obligations under any
                                agreement that these Terms apply without
                                receiving our prior written consent. Any
                                purported assignment or delegation in violation
                                of this section is null and void. No assignment
                                or delegation relieves you of any of your
                                obligations under any agreement where these
                                Terms apply.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Term and Termination
                            </strong>

                            <p>
                                We reserve the right to terminate your account
                                or access to our Website or Service at any time
                                at our sole discretion, for any or no reason,
                                including without limitation, any violation of
                                these Terms or any agreement that these terms
                                govern. You may terminate your account on the
                                Website or Service as well.
                            </p>
                            <p>
                                In addition to any remedies that may be provided
                                under any agreement that these Terms apply, we
                                may terminate any agreement where these Terms
                                apply with immediate effect upon written notice
                                to you, if you:
                            </p>
                            <ol>
                                <li>
                                    fail to pay any amount when due under the
                                    agreement; or
                                </li>
                                <li>
                                    have not otherwise performed or complied
                                    with any of these Terms or the agreement to
                                    which these Terms apply, in whole or in
                                    part.
                                </li>
                            </ol>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Governing Law; Submission to Jurisdiction.
                            </strong>

                            <p>
                                This Agreement and all matters relating hereto
                                are governed by, and construed in accordance
                                with, the laws of the State of ​Ohio, without
                                regard to the conflict of law provisions of such
                                State. Any legal suit, action, or proceeding
                                relating to this Agreement must be instituted in
                                the federal or state courts located in the State
                                of Ohio and the County of Franklin. Each Party
                                irrevocably submits to the exclusive
                                jurisdiction of such courts in any such suit,
                                action, or proceeding.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Arbitration
                            </strong>

                            <p>
                                At our sole discretion, we may require you to
                                submit any disputes arising from these Terms or
                                use of our Website, including disputes arising
                                from or concerning their interpretation,
                                violation, invalidity, non-performance, or
                                termination, to final and binding arbitration
                                under the Rules of Arbitration of the American
                                Arbitration Association applying Ohio law.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Time to File Claim
                            </strong>

                            <p>
                                ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE
                                ARISING OUT OF OR RELATING TO THESE TERMS OR THE
                                WEBSITE MUST BE COMMENCED WITHIN ONE (1) YEAR
                                AFTER THE CAUSE OF ACTION ACCRUES; OTHERWISE,
                                SUCH CAUSE OF ACTION OR CLAIM IS PERMANENTLY
                                BARRED.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Waiver
                            </strong>

                            <p>
                                No waiver by us of any term set forth in these
                                Terms shall be deemed a further or continuing
                                waiver of such term or condition or a waiver of
                                any other term, and any failure of the Company
                                to assert a right or provision under these Terms
                                shall not constitute a waiver of such right or
                                provision.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Severability
                            </strong>

                            <p>
                                If any provision of these Terms is held by a
                                court or other tribunal of competent
                                jurisdiction to be invalid, illegal or
                                unenforceable for any reason, such provision
                                shall be eliminated or limited to the minimum
                                extent such that the remaining provisions of the
                                Terms will continue in full force and effect.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Force Majeure
                            </strong>

                            <p>
                                No party shall be liable or responsible to the
                                other party, nor be deemed to have defaulted
                                under or breached this agreement, for any
                                failure or delay in fulfilling or performing any
                                term of this agreement (except for payment
                                obligations required hereunder), when and to the
                                extent such failure or delay is caused by or
                                results from acts beyond the impacted party's ("
                                <strong>Impacted Party</strong>
                                ") control, including, without limitation, the
                                following force majeure events ("
                                <strong>Force Majeure Event</strong>
                                &rdquo;): (a) acts of God; (b) flood, fire,
                                earthquake, explosion, pandemic, or epidemic;
                                (c) war, invasion, hostilities (whether war is
                                declared or not), terrorist threats or acts,
                                riot or other civil unrest; (d) government
                                order, law, or action, including stay-at-home or
                                shelter-in-place orders; (e) embargoes or
                                blockades in effect on or after the date of this
                                Agreement; and (f) national or regional
                                emergency; and (g) strikes, labor stoppages or
                                slowdowns or other industrial disturbances; and
                                (h) shortage of adequate power or transportation
                                facilities; and (i) other similar events beyond
                                the reasonable control of the Impacted Party.
                                The Impacted Party shall give notice within 7
                                days of the Force Majeure Event to the other
                                party, stating the period of time the occurrence
                                is expected to continue. The Impacted Party
                                shall use diligent efforts to end the failure or
                                delay and ensure the effects of such Force
                                Majeure Event are minimized. The Impacted Party
                                shall resume the performance of its obligations
                                as soon as reasonably practicable after the
                                removal of the cause. If the Impacted
                                Party&rsquo;s failure or delay remains uncured
                                for a period of 30 days following the removal of
                                the Force Majeure Event, the other party may
                                thereafter terminate the agreement upon 5 days'
                                written notice.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Survival
                            </strong>

                            <p>
                                Provisions of these Terms, which by their nature
                                should apply beyond their terms, will remain in
                                full force after any termination or expiration
                                of this agreement.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Integration of Policies and Entire Agreement
                            </strong>

                            <p>
                                These Terms constitute the entire agreement
                                between you and us regarding your use of the
                                Website and our provision of Services and
                                supersede and replace any prior agreements we
                                might have had with you regarding the same.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Notices
                            </strong>

                            <p>
                                All notices, requests, consents, claims,
                                demands, waivers, and other communications
                                hereunder (each, a "
                                <strong>Notice</strong>
                                ") shall be in writing and addressed to the
                                parties at the addresses set forth in the
                                Contacting Us section of these Terms. All
                                Notices must be delivered by personal delivery,
                                nationally recognized overnight courier (with
                                all fees prepaid), facsimile (with confirmation
                                of transmission), or email or certified or
                                registered mail (in each case, return receipt
                                requested, postage prepaid). A Notice is
                                effective only (a) upon receipt of the receiving
                                party, and (b) if the party giving the Notice
                                has complied with the requirements of this
                                section.
                            </p>
                        </li>

                        <li>
                            <strong
                                class="text-lg text-gray-800 font-bold mb-3"
                            >
                                Contacting Us
                            </strong>

                            <p>
                                If you have any comments, questions or concerns,
                                please email us at contact@10xtravel.com.
                            </p>
                        </li>
                    </ol>
                </section>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
</script>
